import MuiAutocomplete from './AutoComplete'
import MuiButton from './Button'
import MuiCheckbox from './Checkbox'
import MuiChip from './Chip'
import MuiFormControl from './FormControl'
import MuiIconButton from './IconButton'
import MuiMenuItem from './MenuItem'
import MuiOutlinedInput from './OutlinedInput'
import MuiPaper from './Paper'
import MuiSelect from './Select'
import MuiSwitch from './Switch'
import MuiTextField from './TextField'
import MuiTypography from './Typography'

const components = {
  MuiButton,
  MuiIconButton,
  MuiPaper,
  MuiTypography,
  MuiTextField,
  MuiChip,
  MuiCheckbox,
  MuiSwitch,
  MuiAutocomplete,
  MuiSelect,
  MuiFormControl,
  MuiOutlinedInput,
  MuiMenuItem,
}

export default components
